/*
 * This page is specifically for the Personal
 * Information section of the Provider Profile
 * Page
 */

import { getProvider, updateProvider } from "../APIs/providerApi";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCurrentUser } from "../APIs/authApi";

export default function ProviderEditProfile({ providerId }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    email: "",
    phoneNumber: "",
    ethnicity: "",
    gender: "",
    yearsOfExperience: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  /*useEffect(() => {
    const fetchProvider = async () => {
      try {
        const data = await getProvider(providerId);
        setFormData({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          dateOfBirth: data.dateOfBirth || "",
          email: data.email || "",
          phoneNumber: data.phoneNumber || "",
          ethnicity: data.ethnicity || "",
          gender: data.gender || "",
          yearsOfExperience: data.yearsOfExperience || "",
        });
      } catch (err) {
        console.error("Failed to fetch provider info:", err);
      }
    };
    fetchProvider();
  }, [providerId]);*/

  useEffect(() => {
    let mounted = true;

    const loadProvider = async () => {
      try {
        // ✅ Canonical source of providerId
        const me = await fetchCurrentUser();
        if (!mounted) return;

        if (!me?.providerId) {
          console.error("ProviderEditProfile: providerId missing from /me");
          return;
        }

        const data = await getProvider(me.providerId);
        if (!mounted) return;

        setFormData({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          dateOfBirth: data.dateOfBirth || "",
          email: data.email || "",
          phoneNumber: data.phoneNumber || "",
          ethnicity: data.ethnicity || "",
          gender: data.gender || "",
          yearsOfExperience: data.yearsOfExperience || "",
        });
      } catch (err) {
        console.error("Failed to load provider profile:", err);
      }
    };

    loadProvider();
    return () => {
      mounted = false;
    };
  }, []);

  const handleChange = (field, value) =>
    setFormData({ ...formData, [field]: value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      //await updateProvider(providerId, formData);
      const me = await fetchCurrentUser();
      if (!me?.providerId) {
        throw new Error("ProviderId missing during update");
      }
      await updateProvider(me.providerId, formData);
      alert("Profile updated successfully!");
      navigate("/provider"); // back to profile page
    } catch (err) {
      console.error("Failed to update provider:", err);
      alert("Error updating profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-2xl font-semibold mb-4">Edit Profile</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="First Name"
          value={formData.firstName}
          onChange={(e) => handleChange("firstName", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <input
          type="text"
          placeholder="Last Name"
          value={formData.lastName}
          onChange={(e) => handleChange("lastName", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <input
          type="date"
          placeholder="Date of Birth"
          value={formData.dateOfBirth}
          onChange={(e) => handleChange("dateOfBirth", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={formData.email}
          onChange={(e) => handleChange("email", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <input
          type="tel"
          placeholder="Phone Number"
          value={formData.phoneNumber}
          onChange={(e) => handleChange("phoneNumber", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <input
          type="text"
          placeholder="Ethnicity"
          value={formData.ethnicity}
          onChange={(e) => handleChange("ethnicity", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <input
          type="text"
          placeholder="Gender"
          value={formData.gender}
          onChange={(e) => handleChange("gender", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <input
          type="number"
          placeholder="Years of Experience"
          value={formData.yearsOfExperience}
          onChange={(e) => handleChange("yearsOfExperience", e.target.value)}
          className="border p-2 w-full rounded"
          required
        />
        <button
          type="submit"
          disabled={loading}
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          {loading ? "Updating..." : "Update Profile"}
        </button>
      </form>
    </div>
  );
}
